"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _SuiteCalcEditionSelectionContainer = _interopRequireDefault(require("pricing-pages-unified-ui/components/growth-suite-page/SuiteCalcEditionSelectionContainer"));

var _SuiteAdditionalUnitsPicker = _interopRequireDefault(require("pricing-pages-unified-ui/components/growth-suite-page/SuiteAdditionalUnitsPicker"));

var _PlanSelectorTileHeader = _interopRequireDefault(require("../calculator/PlanSelectorTileHeader"));

var _Hubs = _interopRequireDefault(require("self-service-api/constants/Hubs"));

var _CalculatorDivider = _interopRequireDefault(require("pricing-pages-unified-ui/components/calculator/CalculatorDivider"));

var _CodeSplitEnvWrapper = _interopRequireDefault(require("pricing-pages-unified-ui/components/CodeSplitEnvWrapper"));

var _SuiteTermSelectorContainer = _interopRequireDefault(require("./SuiteTermSelectorContainer"));

var _PromotionSelectors = require("../../selectors/PromotionSelectors");

var _stateUtils = require("../../utils/stateUtils");

var _itemConfigUtils = require("../../utils/itemConfigUtils");

var _Calculator = require("../calculator/Calculator");

var _CovidSelectors = require("../../selectors/CovidSelectors");

var SuiteCalcPlanSelectorTileContainer = function SuiteCalcPlanSelectorTileContainer(_ref) {
  var _ref2;

  var growthSuiteAvailableTerms = _ref.growthSuiteAvailableTerms;

  var _useContext = (0, _react.useContext)(_Calculator.CalculatorContext),
      state = _useContext.state,
      setState = _useContext.setState;

  var _useActiveTerm = (0, _stateUtils.useActiveTerm)(),
      activeTerm = _useActiveTerm.activeTerm;

  var _useActiveTerm2 = (0, _stateUtils.useActiveTerm)(),
      setActiveTerm = _useActiveTerm2.setActiveTerm;

  var activeEdition = state.edition,
      marketingUnits = state.contacts,
      salesUnits = state.sales_seats,
      serviceUnits = state.service_seats,
      selectedAddOns = state.addons;
  activeTerm = (0, _itemConfigUtils.getApplicableTerm)(activeTerm, growthSuiteAvailableTerms[activeEdition]);
  (0, _react.useEffect)(function () {
    setActiveTerm(activeTerm);
  }, []);

  var getDefaultTerm = function getDefaultTerm(edition) {
    return (0, _itemConfigUtils.getApplicableTerm)(activeTerm, growthSuiteAvailableTerms[edition]);
  };

  var setActiveEdition = function setActiveEdition(edition) {
    var filteredAddons = (0, _stateUtils.filterInvalidAddons)(selectedAddOns, 'growth-suite', activeEdition, edition);
    setState({
      edition: edition,
      contacts: 0,
      sales_seats: 0,
      service_seats: 0,
      addons: filteredAddons
    });
    setActiveTerm(getDefaultTerm(edition));
  };

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_PlanSelectorTileHeader.default, null, _react.default.createElement(_SuiteTermSelectorContainer.default, {
    activeEdition: activeEdition,
    activeTerm: activeTerm,
    onChange: setActiveTerm
  })), _react.default.createElement(_SuiteCalcEditionSelectionContainer.default, {
    activeEdition: activeEdition,
    setActiveEdition: setActiveEdition
  }), _react.default.createElement(_CalculatorDivider.default, null), _react.default.createElement(_SuiteAdditionalUnitsPicker.default, {
    activeEdition: activeEdition,
    activeTerm: activeTerm,
    additionalUnitQuantities: (_ref2 = {}, (0, _defineProperty2.default)(_ref2, _Hubs.default.HUB_MARKETING, marketingUnits), (0, _defineProperty2.default)(_ref2, _Hubs.default.HUB_SALES, salesUnits), (0, _defineProperty2.default)(_ref2, _Hubs.default.HUB_SERVICE, serviceUnits), _ref2),
    setAdditionalUnitQuantity: setState
  }), _react.default.createElement(_CalculatorDivider.default, null), _react.default.createElement(_CodeSplitEnvWrapper.default, {
    authedComponentLoader: function authedComponentLoader() {
      return import(
      /* webpackChunkName: "authed-chunk" */
      "pricing-pages-unified-ui/components/calculator/AddonsAndServices/AddonsAndServices");
    },
    publicComponentLoader: function publicComponentLoader() {
      return import(
      /* webpackChunkName: "public-chunk" */
      "pricing-pages-unified-ui/components/calculator/AddonsAndServices/AddonsAndServicesList");
    },
    publicComponentProps: {
      hub: 'growth-suite',
      edition: activeEdition
    }
  }));
};

var mapStateToProps = function mapStateToProps(state) {
  var isCovidPromo = (0, _CovidSelectors.isCovidGrowthSuitePromoEligibleSelector)(state);
  return {
    growthSuiteAvailableTerms: (0, _PromotionSelectors.growthSuiteAvailableTermsSelector)(state, isCovidPromo)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(SuiteCalcPlanSelectorTileContainer);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/growth-suite-page/SuiteCalcPlanSelectorTileContainer.js
// module id = 866
// module chunks = 5 6